<template>
    <div class="reject-reason-box audit-panel">
        <div class="form-group deny-reason-box">
            <div class="audit-panel-title">请选择驳回原因</div>
        </div>
        <!-- <el-form ref="form" :model="form">
            <el-form-item label="涉政:">
                <el-radio-group v-model="form.politics" class="check-header" size="small">
                    <el-radio label="politics_1">涉政一级</el-radio>
                    <el-radio label="politics_2">涉政二级</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="涉黄:">
                <el-radio-group v-model="form.pornographic" class="check-header" size="small">
                    <el-radio label="pornographic_1" class="radioSpan">涉黄一级</el-radio>
                    <el-radio label="pornographic_2" class="radioSpan">涉黄二级</el-radio><br /><br />
                    <el-radio label="pornographic_3" class="radioSpan">涉黄三级</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="暴恐:">
                <el-radio-group v-model="form.violence" class="check-header" size="small">
                    <el-radio label="violence_1">暴恐一级</el-radio>
                    <el-radio label="violence_2">暴恐二级</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="违禁:">
                <el-checkbox-group v-model="form.violate">
                    <el-checkbox label="violate">违禁</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="广告:" label-position="left">
                <el-checkbox-group v-model="form.advert">
                    <el-checkbox label="advert">广告</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="定不了性:">
                <el-checkbox-group v-model="form.qualitative">
                    <el-checkbox label="qualitative" name="advert">定不了性</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="备注:">
                <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="form.note"> </el-input>
            </el-form-item>
        </el-form> -->
        <el-form ref="form" :model="form">
            <el-form-item label="涉政:">
                <el-checkbox-group v-model="form.checkList">
                    <el-popover
                        placement="top"
                        width="300"
                        trigger="hover"
                        v-for="(item, $key) in config.politics"
                        :key="$key"
                    >
                        <div>
                            <el-checkbox-group v-model="form.politics[item.k]">
                                <el-checkbox
                                    class="min-width"
                                    v-for="option in item.detail"
                                    :key="option.id"
                                    :label="option.id"
                                    :value="option.id"
                                    @change="handleCheck(item.k, 'politics')"
                                    >{{ option.reason }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </div>
                        <el-checkbox class="ml20" disabled slot="reference" :label="item.k" :value="item.k">{{
                            item.v
                        }}</el-checkbox>
                    </el-popover>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="涉黄:">
                <el-checkbox-group v-model="form.checkList">
                    <el-popover
                        placement="top"
                        width="300"
                        trigger="hover"
                        v-for="(item, $key) in config.pornographic"
                        :key="$key"
                    >
                        <div>
                            <el-checkbox-group v-model="form.pornographic[item.k]">
                                <el-checkbox
                                    class="min-width"
                                    v-for="option in item.detail"
                                    :key="option.id"
                                    :label="option.id"
                                    :value="option.id"
                                    @change="handleCheck(item.k, 'pornographic')"
                                    >{{ option.reason }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </div>
                        <el-checkbox class="ml20" disabled slot="reference" :label="item.k" :value="item.k">{{
                            item.v
                        }}</el-checkbox>
                    </el-popover>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="暴恐:">
                <el-checkbox-group v-model="form.checkList">
                    <el-popover
                        placement="right"
                        width="300"
                        trigger="hover"
                        v-for="item in config.violence"
                        :key="item.k"
                    >
                        <div>
                            <el-checkbox-group v-model="form.violence[item.k]">
                                <el-checkbox
                                    class="min-width"
                                    v-for="option in item.detail"
                                    :key="option.id"
                                    :label="option.id"
                                    :value="option.id"
                                    @change="handleCheck(item.k, 'violence')"
                                    >{{ option.reason }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </div>
                        <el-checkbox class="ml20" disabled slot="reference" :label="item.k" :value="item.k">{{
                            item.v
                        }}</el-checkbox>
                    </el-popover>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="违禁:">
                <el-checkbox-group v-model="form.checkList">
                    <el-popover
                        placement="top"
                        width="300"
                        trigger="hover"
                        v-for="item in config.violate"
                        :key="item.k"
                    >
                        <div>
                            <el-checkbox-group v-model="form.violate[item.k]">
                                <el-checkbox
                                    class="min-width"
                                    v-for="option in item.detail"
                                    :key="option.id"
                                    :label="option.id"
                                    :value="option.id"
                                    @change="handleCheck(item.k, 'violate')"
                                    >{{ option.reason }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </div>
                        <el-checkbox class="ml20" disabled slot="reference" :label="item.k" :value="item.k">{{
                            item.v
                        }}</el-checkbox>
                    </el-popover>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="广告:">
                <el-checkbox-group v-model="form.checkList">
                    <el-popover placement="top" width="300" trigger="hover" v-for="item in config.advert" :key="item.k">
                        <div>
                            <el-checkbox-group v-model="form.advert[item.k]">
                                <el-checkbox
                                    class="min-width"
                                    v-for="option in item.detail"
                                    :key="option.id"
                                    :label="option.id"
                                    :value="option.id"
                                    @change="handleCheck(item.k, 'advert')"
                                    >{{ option.reason }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </div>
                        <el-checkbox class="ml20" disabled slot="reference" :label="item.k" :value="item.k">{{
                            item.v
                        }}</el-checkbox>
                    </el-popover>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="备注:">
                <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="form.note"> </el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import auditConfig from '@/module/AuditConfig';

export default {
    props: {
        form: {
            type: Object,
            default () {
                return {
                    checkList: [],
                    politics: [], // 涉及政治.
                    porn: [], // 涉及色情.
                    terror: [], // 涉及恐怖.
                    banned: [], // 违禁。
                    advertising: [], // 广告.
                    stereotyped: [], // 定性不了.
                    msg: ''
                };
            }
        },
        config: {
            type: Object,
            default () {
                return {};
            }
        },
        type: {
            type: String,
            default: '2'
        }
    },
    data () {
        return {};
    },
    methods: {
        reset () {
            this.$refs['form'].resetFields();
        },
        handleCheck (k, f) {
            this.$emit('handleChecked', k, f);
        }
    },
    mounted () {
        document.addEventListener(
            'keyup',
            function (event) {
                event.preventDefault();
            },
            false
        );
    }
};
</script>
<style lang="less" scoped>
.audit-common-box .ml20 {
    margin-right: 5px;
}
</style>
<style lang="less">
.radioSpan {
    padding: 5px;
}
.el-form-item {
    margin-bottom: 5px;
}

.min-width {
    min-width: 200px;
    .el-checkbox__label {
        max-width: 256px;
        word-break: break-all;
        white-space: pre-wrap;
        vertical-align: top;
    }
}
/*.reject-reason-box {*/
/*.ft-controls, .check-body {*/
/*margin-top: 10px;*/
/*}*/
/*}*/
/*.new-addit-size{*/
/*.el-checkbox{*/
/*width: 72px;*/
/*font-weight: normal;*/
/*color: #1f3d3c;*/
/*margin-right: 15px;*/
/*}*/
/*.el-checkbox__label{*/
/*padding-left: 5px;*/
/*line-height: 26px;*/
/*}*/
/*.el-checkbox__inner{*/
/*width: 17px;*/
/*height: 17px;*/
/*}*/
/*}*/
</style>
